import {jsPDF} from "jspdf";
import * as htmlToImage from 'html-to-image';

import { orionLogoJPG } from 'src/assets/images';

const PDF_BLOCK_W = 500;
const PDF_BLOCK_H = 650;
const PDF_IMG_W = 642;
const PDF_IMG_H = Math.round(PDF_IMG_W * (PDF_BLOCK_H / PDF_BLOCK_W));
const CANVAS_W = 2000;
const CANVAS_H = Math.round(CANVAS_W * (PDF_BLOCK_H / PDF_BLOCK_W));

const buildPDFDoc = async (): Promise<jsPDF | null> => {
  const element = document.getElementById("pdf_for_save");
  if (!element) return null;

  const doc = new jsPDF({orientation: 'portrait', unit: 'px', hotfixes: ['px_scaling']});

  const img = new Image();
  img.src = await htmlToImage.toPng(element as HTMLElement, {
    canvasHeight: CANVAS_H,
    canvasWidth: CANVAS_W,
    width: img.width,
    height: img.height,
  });

  await doc.addImage(orionLogoJPG, 'JPG', 598,76,120,50);
  await doc.addImage(img, 'PNG', 76, 164, PDF_IMG_W, PDF_IMG_H);
  return doc;
};

export const generatePDF = async ():Promise<void> => {
  try {
    const doc = await buildPDFDoc();
    if (doc) {
      await doc.save('price');
    }
  } catch (e) {
    console.log(e)
  }
};

export const generatePDFFile = async (): Promise<File | null> => {
  try {
    const element = document.getElementById("pdf_for_save");
    if (!element) return null;

    const doc = new jsPDF({orientation: 'portrait', unit: 'px', hotfixes: ['px_scaling']});

    const FILE_CANVAS_W = 800;
    const FILE_CANVAS_H = Math.round(FILE_CANVAS_W * (PDF_BLOCK_H / PDF_BLOCK_W));

    const imgSrc = await htmlToImage.toJpeg(element as HTMLElement, {
      canvasHeight: FILE_CANVAS_H,
      canvasWidth: FILE_CANVAS_W,
      quality: 0.8,
    });

    await doc.addImage(orionLogoJPG, 'JPG', 598,76,120,50);
    await doc.addImage(imgSrc, 'JPEG', 76, 164, PDF_IMG_W, PDF_IMG_H);

    const blob = doc.output('blob');
    return new File([blob], 'price.pdf', { type: 'application/pdf' });
  } catch (e) {
    console.log(e);
    return null;
  }
};

export default generatePDF;
